/**
 *
 * @param {jQuery | JQuery} nav
 */
export function mobileTouchFix(nav) {
    nav.find('a').on('touchend', function (event) {
        if ($(this).siblings('ul').length === 1) {
            if (!$(this).hasClass('hovered')) {
                event.preventDefault();
                $(this).parents('ul').find('a').removeClass('hovered').parents('li').removeClass('hover');
            }
            $(this).addClass('hovered').parents('li').addClass('hover');
        }
    });
}